var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBrifecaseTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.761 5.57h-.24v-.04c0-1.68 0-3.76-3.76-3.76h-1.52c-3.76 0-3.76 2.08-3.76 3.76v.04h-.24c-2.07 0-3.49.47-4.33 1.41-.99 1.11-.96 2.58-.86 3.59l.01.07.07.806a.5.5 0 0 0 .226.377c.378.244.67.423.874.537.14.09.29.17.44.25 1.13.62 2.34 1.11 3.58 1.45a4.755 4.755 0 0 0 4.75 4.69c2.62 0 4.75-2.13 4.75-4.75v-.04c1.26-.38 2.47-.91 3.6-1.57.06-.03.1-.06.15-.09.46-.25.94-.59 1.36-.89l.09-.83c.01-.06.01-.11.02-.18.08-1 .06-2.38-.88-3.42-.85-.94-2.26-1.41-4.33-1.41zm-5.52-2.38h1.52c2.33 0 2.33.64 2.33 2.34v.04h-6.18v-.04c0-1.7 0-2.34 2.33-2.34zm-2.46 11.22c-.02-.13-.03-.27-.03-.41 0-1.79 1.46-3.25 3.25-3.25s3.25 1.46 3.25 3.25c0 .12-.01.23-.02.34v.01a3.258 3.258 0 0 1-3.23 2.9 3.25 3.25 0 0 1-3.22-2.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.899 15.808-.99-.98a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.48.48 1.61-1.48c.3-.28.78-.26 1.06.04s.26.78-.04 1.06l-2.13 1.97c-.16.12-.34.19-.52.19-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.232 17.961c-.21 2-1.03 4.04-5.43 4.04h-7.62c-4.4 0-5.22-2.04-5.42-4.03l-.345-3.693a.365.365 0 0 1 .535-.357c.78.43 1.59.81 2.42 1.11a1 1 0 0 1 .62.69c.75 2.6 3.17 4.53 6.01 4.53 2.89 0 5.33-1.97 6.04-4.67a1 1 0 0 1 .61-.7c.84-.33 1.64-.72 2.39-1.15.09-.05.58-.34.61-.36l-.42 4.59z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBrifecaseTick);
export default __webpack_public_path__ + "static/media/vuesax-bold-brifecase-tick.cd2c5ddbc94293d5f8b0f6d743a3dc4f.svg";
export { ForwardRef as ReactComponent };